import React from 'react';
import { Card, Col, Row } from 'antd';
import { hideSharePopupAction } from 'components/share/share.actions';
import {getURLwithoutPro, goToMintPackDetails, isProUser } from '../../__utils/common-utils';
import { getFormDataFromJson, fetchPost } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import {  useDispatch } from 'react-redux';
import useFlashToggler from 'hooks/use-flash-toggler';
import ShareButton from 'components/share-button';

import './index.css';
import { CommonStyledComponentProps } from '__utils/type';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';

interface PintPacksProps {
  mintPackList: any;
}

const MintpackContainer = styled.div<CommonStyledComponentProps>`
  .mintpack-desc-sec .mintpack-perc {
    font-size: ${(props) => props.isMobile ? '12px' : '14px'};
  }
  .mintpack-desc-sec .mintpack-title{
    font-size: ${(props) => props.isMobile ? '14px' : '16px'};
  }
  .mintpack-desc-sec .share-btn > div {
    border: ${(props) => props.isMobile ? 'none' : '1px solid rgb(0, 164, 101)'};
    padding: ${(props) => props.isMobile ? '0' : '8px 16px'};
    display: ${(props) => props.isMobile ? 'block' : 'flex'};
  }
  .mintpack-img > img{
    height: ${(props) => props.isMobile ? '' : '136px'};
  }
`

const MintpacksCard = ({mintPackList}:PintPacksProps) => {
  const dispatch = useDispatch();
  const flash = useFlashToggler();
  const isMobile = useMediaQuery({ maxWidth: 767 });


  const getShareMintPackMsg = (mintpack:any) => {
    return window.encodeURIComponent(
      `Get started by replying to this message. \n${getShareURL(mintpack)}`
    )
  }

  const getShareURL = (mintpack:any) => {
    return getURLwithoutPro(`/mint-pack-details?mintpackIds=${mintpack.encryptedMintPackId}`);
  }

  //@purpose: share via email/sms
  const shareMintPackDetails = (value: string, type:any, mintpack:any) => {
    const shareType = type === 'email' ? 'email' : 'sms';
    const formData = getFormDataFromJson({
      type: type,
      value: value,
      mintpackName: mintpack?.goalName,
      mintpackDesc: mintpack?.description,
      mintpackUrl: getShareURL(mintpack),
    });
      fetchPost(
        ENDPOINTS.POST_SHARE_MINTPACK_LINK, formData, null, true)
        .then((response: any) => {
            if (response?.operationMessage === 'success') {
              flash.success('Shared Mintpack successfully.!');
              dispatch(hideSharePopupAction());
            } else if(response?.operationMessage === 'failure') {
              flash.error(response?.responseData);
              dispatch(hideSharePopupAction());
            }
          }).catch(() => {
            flash.error("Failed to share Mintpack link. Please try again later.");
            dispatch(hideSharePopupAction());
        });
    }

  return(
    <MintpackContainer isMobile={isMobile}>
      <Row gutter={[24, 24]} style={{flexFlow:'unset'}}>
        {mintPackList?.map((mintpack: any, index:number) => {
          return (
            <Col xs={20} md={11} key={index} className='mb16'>
              <Card className={isMobile ? 'mintpack-card mintpack-card-mobile' : 'mintpack-card' }bordered={false} style={{boxShadow: '0 2px 12px 0 #cecece', borderRadius: '4px', cursor: 'pointer'}}>
                <Row>
                  <Col xs={24} md={24}>
                    <div className='mintpack-img' onClick={() => goToMintPackDetails(mintpack)} >
                      <img src={mintpack.imageUrl} />
                    </div>
                    <div className="mintpack-desc-sec">
                      <Row>
                        <Col xs={16} onClick={() => goToMintPackDetails(mintpack)} >
                          <h4 className='mintpack-title'>{mintpack.goalName}</h4>
                          <p className='mintpack-perc'>3yrs Rolling Ret: <b>{mintpack.rollingReturns.toFixed(2)}%</b></p>
                        </Col>
                        {isProUser()&&
                          <Col xs={8} onClick={(e: any)=>e.preventDefault()}>
                            <div className='share-btn'>
                              <ShareButton shareConfig=
                                {{
                                  message: getShareMintPackMsg(mintpack),
                                  shareUrl: getShareURL(mintpack),
                                  onEmailOrSMSShare: shareMintPackDetails,
                                  shareItemDetails: mintpack,
                                  shareType: 'shareMintPackDetails',
                                  sharePopupText: 'Share Mintpack via',
                                  mixpanelData: { eventName: 'shareMintpack', source: 'mintpack' }
                                }}
                              />
                            </div>
                          </Col>
                        }
                      </Row>
                      {mintpack?.showDescription &&
                        <Row>
                          <Col xs={24}>
                            <p className='mintpack-txt'>{mintpack.description}</p>
                          </Col>
                        </Row>
                      }
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          )
        })}
      </Row>
    </MintpackContainer>
  )
}
export default MintpacksCard;